import Vue from 'vue'
import Vuex from 'vuex'
import { auth } from './auth.module';
import { Workspaces } from '@/class/workspace_class'
import { Devices }    from '@/class/devices_class'
import { Faces }    from '@/store/face.module'
import { ListDetails }  from '@/store/list.module'
import { Analytics }  from '@/store/analytic.module'
import { Tags }  from '@/store/tag.module'
import { Counter }  from '@/store/counter.module'
import { Dashboard } from '@/store/dashboard.module.js'


Vue.use(Vuex)

export default new Vuex.Store({
  state: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
  	auth,
    Workspaces,
    Devices,
    Faces,
    ListDetails,
    Analytics,
    Tags,
    Counter,
    Dashboard,
  }
})
